import { createFileRoute } from '@tanstack/react-router';
import { Outlet } from '@/lib/router-components';

export const Route = createFileRoute('/w/$workspaceId/clients/$clientId/processes')({
  component: ProcessesLayout,
});

// Esta rota intermediária existe apenas para permitir rotas filhas como /processes/$processId
// A lista de processos está na página do cliente (/w/$workspaceId/clients/$clientId), não aqui
function ProcessesLayout() {
  // Esta rota apenas renderiza o Outlet para permitir rotas filhas
  // Não renderiza nada, apenas passa a responsabilidade para as rotas filhas
  return <Outlet />;
}
